export function getCanvasPosFromEvent(event: MouseEvent | TouchEvent): number[] {
  const canvas = event.target as HTMLCanvasElement;
  const rect = canvas.getBoundingClientRect();

  if (window.TouchEvent && event instanceof TouchEvent) {
    const touch = event.touches[0] || event.changedTouches[0];
    return [touch.clientX - rect.left, touch.clientY - rect.top];
  } else {
    return [(event as MouseEvent).clientX - rect.left, (event as MouseEvent).clientY - rect.top];
  }
}
